document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
function onDOMContentLoaded() {
  initFeatureAccordion();
  initCaseSlider();
  initFixedButton();
}
/* -------------------------------------------------------------------------------------
 initCaseSlider
------------------------------------------------------------------------------------- */
const caseSliderWrapIds = ["caseSlider-wrap1", "caseSlider-wrap2"];
const swipers = [];
function initCaseSlider() {
  for (const id of caseSliderWrapIds) {
    const swiper = new Swiper("#"+id+" .caseSlider", {
      slidesPerView: "auto",
      spaceBetween: 40,
      pagination: {
        el: "#"+id+" .swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: "#"+id+" .swiper-button-next",
        prevEl: "#"+id+" .swiper-button-prev",
      },
      breakpoints: {
        0: {
          spaceBetween: 0,
        },
        768: {
          spaceBetween: 40,
        }
      },
    });
    swipers.push(swiper);
  }
}
/* -------------------------------------------------------------------------------------
 initFeatureAccordion
------------------------------------------------------------------------------------- */
function initFeatureAccordion() {
  document.querySelector(".accordion-btn").addEventListener("click", (e) => {
    document.querySelector('.feature-accordion').classList.toggle("is-open");
  });
}
/* -------------------------------------------------------------------------------------
 initFixedButton
------------------------------------------------------------------------------------- */
function initFixedButton() {
  document.addEventListener('scroll', function() {
    const scrollPosition = window.scrollY || window.pageYOffset; // 現在のスクロール位置
    const totalPageHeight = document.documentElement.scrollHeight; // ページ全体の高さ
    const windowHeight = window.innerHeight; // ビューポートの高さ
    const bottomOffset = totalPageHeight - windowHeight - 800; // ページの最後から800px手前

    const target = document.querySelector('.fixed-button'); // クラスを付与する対象の要素

    // 500px以上スクロールしたらクラスを付与
    if (scrollPosition >= 500) {
      target.classList.add('active');
    } else {
      target.classList.remove('active');
    }
    // 最後から800px手前までスクロールしたらクラスを外す
    if (scrollPosition >= bottomOffset) {
      target.classList.remove('active');
    }
  });
}
